import apiFetch from '../../apiFetch'

export default function (token, processingAgencyId, processingAgencyServiceDestinationsId) {
  return apiFetch({ endPoint: `ProcessingAgency/${processingAgencyId}/ServiceDestinations/${processingAgencyServiceDestinationsId}`, method: 'DELETE', body: null, token: token })
}
